import { render, staticRenderFns } from "./DetailPiLunPop.vue?vue&type=template&id=056a5e47&"
import script from "./DetailPiLunPop.vue?vue&type=script&lang=js&"
export * from "./DetailPiLunPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports